// extracted by mini-css-extract-plugin
export default {"wrapper":"bGtRfYxsDqf6PJ0Ri1Ji"};